// Document version diff utility

function diffDocumentVersions(prev, next) {
  const changes = [];
  if (prev.title !== next.title) changes.push(`Title changed: "${prev.title}" → "${next.title}"`);
  if (prev.version !== next.version)
    changes.push(`Version bumped: ${prev.version} → ${next.version}`);
  if (prev.owner !== next.owner) changes.push(`Owner changed: "${prev.owner}" → "${next.owner}"`);
  if (prev.status !== next.status) changes.push(`Status changed: ${prev.status} → ${next.status}`);
  if (prev.category !== next.category)
    changes.push(`Category changed: ${prev.category} → ${next.category}`);
  if (prev.description !== next.description) changes.push('Description updated');
  if (prev.slaDays !== next.slaDays)
    changes.push(`Review SLA changed: ${prev.slaDays}d → ${next.slaDays}d`);
  if (prev.nextReview !== next.nextReview) changes.push(`Next review date updated`);
  const ctrlId = (c) => (typeof c === 'string' ? c : c.controlId || c.id || '');
  const prevIds = new Set((prev.controls || []).map(ctrlId));
  const nextIds = new Set((next.controls || []).map(ctrlId));
  const addedCtrl = [...nextIds].filter((id) => id && !prevIds.has(id));
  const removedCtrl = [...prevIds].filter((id) => id && !nextIds.has(id));
  if (addedCtrl.length) changes.push(`Controls added: ${addedCtrl.join(', ')}`);
  if (removedCtrl.length) changes.push(`Controls removed: ${removedCtrl.join(', ')}`);
  return changes.length ? changes : ['Minor update (no tracked field changes)'];
}

export { diffDocumentVersions };
